import { buildRichtextHtmlMap } from 'features/EmailEditor/campaignEmailCustomizationHelpers'
import { getTemplate, resolveEditorTemplateKey } from 'features/EmailEditor/templates'
import {
  extractPreviewBodyHtml,
  extractSocialMediaUrls,
  generateSocialMediaLinksHtml,
  getHtmlFromMjml,
  normalizeEmailFooterFields,
  replaceTagsWithPreviewContent,
  resolveSocialFooterTheme
} from 'features/EmailEditor/utils'

const SHELL_PREVIEW_HEADER_BG = '#00723f'

export function buildShellTemplatePreviewHtml(templateKey, userName = 'Guest') {
  const resolvedKey = resolveEditorTemplateKey(templateKey)
  const currentTemplate = getTemplate(resolvedKey)
  const emailState = {
    ...currentTemplate.params,
    headerBgColor: SHELL_PREVIEW_HEADER_BG
  }

  const socialUrls = extractSocialMediaUrls(emailState.socialMediaLinks)
  const templateVariables = normalizeEmailFooterFields({
    ...emailState,
    ...socialUrls
  })

  const socialTheme = resolveSocialFooterTheme(resolvedKey)

  const html = getHtmlFromMjml(currentTemplate.template, templateVariables, {
    ...buildRichtextHtmlMap(emailState.richtextFields || {}),
    socialMediaLinksHtml: generateSocialMediaLinksHtml(
      emailState.socialMediaLinks,
      socialTheme.theme,
      socialTheme.brandColor
    )
  }, { templateKey: resolvedKey })

  return replaceTagsWithPreviewContent(extractPreviewBodyHtml(html), userName)
}

export default buildShellTemplatePreviewHtml
